import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { DashboardSalvar, DashboardWidget, ModuloDashboard, WidgetCatalogo } from '../types/Dashboard.type';

@Injectable({
  providedIn: 'root'
})
export class DashboardApiService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  modulos() {
    return this.httpClient.get<ModuloDashboard[]>(`${this.configService.getApiUrl()}/dashboard/modulos`);
  }

  widgetsDoModulo(moduloId: string) {
    return this.httpClient.get<WidgetCatalogo[]>(`${this.configService.getApiUrl()}/dashboard/widgets/modulo/${moduloId}`);
  }

  carregar() {
    return this.httpClient.get<DashboardWidget[]>(`${this.configService.getApiUrl()}/dashboard`);
  }

  salvar(dto: DashboardSalvar) {
    return this.httpClient.put<DashboardWidget[]>(`${this.configService.getApiUrl()}/dashboard`, dto);
  }
}
